import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_light_bulb.svg';
import Icon, { IconProps } from './icon';

const IconLightBulb = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconLightBulb;
